import { render } from "./SelectAgendaItemModal.vue?vue&type=template&id=bc240eac&scoped=true"
import script from "./SelectAgendaItemModal.vue?vue&type=script&lang=js"
export * from "./SelectAgendaItemModal.vue?vue&type=script&lang=js"

import "./SelectAgendaItemModal.vue?vue&type=style&index=0&id=bc240eac&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc240eac"]])

export default __exports__